import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private PurchseOrderPositions Types */
import {
  Settings,
  _PurchaseOrderPosition
} from '../namespace-helper'

import _ from 'lodash'

const initSelectedPurchaseOrderPosition = {
  id: 0,
  purchase_orders_id: 0,
  purchase_orders_positions_status_id: 0,
  customers_offers_position_id: 0,
  suppliers_offers_positions_id: '',
  delivery_times_id: 0,
  products_id: 0,
  vats_id: 0,
  quantity: null,
  unit_purchase_price: null,
  unit_sales_price: null,
  total_sales_price: null,
  description: null,
  remark: null,
  customers_offers_position: {
    description: null,
    customers_offer: {
      currency: {
        name: null
      },
      customer: {},
      message: {
        attachments: [
          {
            documents_id: 0
          }
        ]
      }
    },
    delivery_time: {}
  },
  product: {
    manufacturer: {
      name: null
    },
    product_description: {
      description: null
    }
  },
  supplier_offers_position: {
    suppliers_offer: {
      supplier: {},
      currency: {}
    },
    delivery_time: {},
    discounts: []
  },
  unit: {
    code: ''
  }
}

export default {
  namespaced: true,
  state: {
    purchaseOrderPositions: [],
    selectedPurchaseOrderPosition: _.cloneDeep(initSelectedPurchaseOrderPosition),
    openDialog: false,
    creatingPurchaseOrderPositions: false
  },
  mutations: {
    [_PurchaseOrderPosition.mutations.setPurchaseOrderPositions] (state, payload) {
      state.purchaseOrderPositions = payload
    },
    [_PurchaseOrderPosition.mutations.setSelectedPurchaseOrderPosition] (state, payload) {
      if (payload !== null) {
        state.selectedPurchaseOrderPosition = payload
      } else {
        state.selectedPurchaseOrderPosition = _.cloneDeep(initSelectedPurchaseOrderPosition)
      }
    },
    [_PurchaseOrderPosition.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_PurchaseOrderPosition.mutations.setCreatingPurchaseOrderFromCustomerOffer] (state, payload) {
      state.creatingPurchaseOrderFromCustomerOffer = payload
    }
  },
  actions: {
    [_PurchaseOrderPosition.actions.savePurchaseOrderPosition] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/purchaseOrderPositions'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_PurchaseOrderPosition.mutations.setSelectedPurchaseOrderPosition, r.data.data)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/purchaseOrderPositions/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_PurchaseOrderPosition.mutations.setSelectedPurchaseOrderPosition, r.data.data)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_PurchaseOrderPosition.actions.loadPurchaseOrderPositions] (context, payload) {
      console.log('loadPurchaseOrderPositions: ' + JSON.stringify(payload))
      console.log('loadPurchaseOrderPositions: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/purchaseOrderPositions/order/' + payload.id + '?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;purchase_orders_number:like;customer.name:like;account.firstname:like;purchaseOrdersStatus.name:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedOrders: ' + JSON.stringify(r.data.data))
        context.commit(_PurchaseOrderPosition.mutations.setPurchaseOrderPositions, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_PurchaseOrderPosition.actions.getReadyForInvoicePositions] (context, payload) {
      console.log('getReadyForInvoicePositions: ' + JSON.stringify(payload))
      console.log('getReadyForInvoicePositions: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/purchaseOrderPositions/' + payload.customers_id + '/' + payload.customers_branch_offices_id + '/' + payload.invoices_id + '/getReadyForInvoicePositions' + '?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;' +
                'purchaseOrder.purchase_orders_number:like;' +
                'purchaseOrder.customer_purchase_order_number:like;' +
                'product.reference:like;' +
                'internal_number:like;' +
                '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      return new Promise((resolve, reject) => {
        return axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PurchaseOrderPosition.actions.deleteOrderPositions] (context, payload) {
      var url = API_URL + '/api/v1/purchaseOrderPositions/' + payload.id

      console.log('deleteOrderPosition: ' + payload.id)

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PurchaseOrderPosition.actions.openCloseDialog] ({ commit }) {
      commit(_PurchaseOrderPosition.mutations.setOpenCloseDialogState)
    },
    [_PurchaseOrderPosition.actions.setSelectedPurchaseOrderPosition] ({ commit }, payload) {
      commit(_PurchaseOrderPosition.mutations.setSelectedPurchaseOrderPosition, payload)
    },
    [_PurchaseOrderPosition.actions.reloadSelectedPurchaseOrderPosition] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      var url = API_URL + '/api/v1/purchaseOrderPositions/' + payload
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_PurchaseOrderPosition.mutations.setSelectedPurchaseOrderPosition, r.data.data)
          resolve(r)
        }, function (err) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PurchaseOrderPosition.actions.resetState] ({ commit }, payload) {
      commit(_PurchaseOrderPosition.mutations.setPurchaseOrderPositions, [])
      commit(_PurchaseOrderPosition.mutations.setSelectedPurchaseOrderPosition, null)
    }
  },
  getters: {
    [_PurchaseOrderPosition.getters.purchaseOrderPositions] (state) {
      return state.purchaseOrderPositions
    },
    [_PurchaseOrderPosition.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_PurchaseOrderPosition.getters.getSelectedPurchaseOrderPosition] (state) {
      return state.selectedPurchaseOrderPosition
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/PurchaseOrderPositions/purchaseOrderPositions.js